<template>
  <nav v-if="shouldPaginate" class="pagination text-center">
    <span v-if="prevPage" class="prev">
      <a @click="goToPage(prevPage)" class="btn-oval btn-oval--transparent">
        <span class="icon icon-arrow-left"></span>
      </a>
    </span>
    <span
      v-for="page in totalPages"
      :key="page"
      class="p-0"
    >
      <div>
        <span
          v-if="isCurrentPage(page)"
          class="page current"
        >
          <a>{{ page }}</a>
        </span>
        <span
          v-else
          class="page"
        >
          <a @click="goToPage(page)">
            {{ page }}
          </a>
        </span>
      </div>
    </span>
    <span v-if="nextPage" class="next">
      <a
        @click="goToPage(nextPage)"
        class="btn-oval btn-oval--transparent"
      >
        <span class="icon icon-arrow-right"></span>
      </a>
    </span>
  </nav>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'BidsPagination',
    props: {
      meta: Object,
      auctionId: String,
    },
    computed: {
      prevPage() {
        return this.meta.prev_page;
      },
      nextPage() {
        return this.meta.next_page;
      },
      currentPage() {
        return this.meta.current_page;
      },
      totalPages() {
        return this.meta.total_pages;
      },
      shouldPaginate() {
        return this.meta && this.meta.total_pages !== 1;
      },
    },
    methods: {
      ...mapActions(['fetchAuctionsBids']),
      isCurrentPage(pageNumber) {
        return pageNumber === this.currentPage;
      },
      goToPage(pageNumber) {
        this.fetchAuctionsBids({ id: this.auctionId, page: pageNumber });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees_orders_panel/components/bids_pagination.vue?7ee945e4